export const PLAYER_COLOR = '#1a5dc6';
export const BANKER_COLOR = '#ce1822';
export const TIE_COLOR = '#46a647';
export const DRAGON_COLOR = '#ce1822';
export const TIGER_COLOR = '#1a5dc6';
export const BOWLER_COLOR = '#ce1822';
export const BATSMAN_COLOR = '#1a5dc6';
export const NATURAL_COLOR = '#ffd400';
export const NEUTRAL_COLOR = '#9ca8c2';
export const GAME_BOARD_BG_COLOR = '#121539';
export const GAME_BOARD_BG_COLOR_WITH_OPACITY = 'rgba(18, 21, 57, 0.9)';
export const PLAYER_BOARD_TEXT_COLOR = '#62d9ff';
export const BANKER_BOARD_TEXT_COLOR = '#ff8282';
export const TIE_BOARD_TEXT_COLOR = '#64f861';
export const PLAYER_BOARD_DARK_TEXT_COLOR = '#0F3886';
export const BANKER_BOARD_DARK_TEXT_COLOR = '#7D081D';
export const TIE_BOARD_DARK_TEXT_COLOR = '#195725';
export const PANDA_EIGHT_COLOR = '#5FA7EA';
export const DRAGON_SEVEN_COLOR = '#FFA800';

export const BOARD_COLORS = {
  PLAYER: '#0098ff',
  BANKER: '#ff252f',
  TIE: '#30d832',
  SIDEBETS: '#9ca8c2',
  SUPER_SIX: '#c030d8',
  DRAGON: '#ff252f',
  TIGER: '#0098ff',
  BOWLER: '#ff252f',
  BATSMAN: '#0098ff',
};

export const ROAD_COLORS_V2 = {
  PLAYER_COLOR: '#092BA1',
  BANKER_COLOR: '#9D0A15',
  TIE_COLOR: '#186224',
  NATURAL_COLOR: '#F0BB00',
};

export const ROADS_LOBBY_COLORS_V2 = {
  PLAYER_COLOR: '#1A83FF',
  BANKER_COLOR: '#EC0F1C',
};

export const EZ_BOARD_COLORS = {
  PLAYER: '#ffffff',
  BANKER: '#ffffff',
  TIE: '#642B1D',
  PANDA_EIGHT: '#ffffff',
  DRAGON_SEVEN: '#ffffff',
};

export default {
  PLAYER_COLOR,
  BANKER_COLOR,
  TIE_COLOR,
  DRAGON_COLOR,
  TIGER_COLOR,
  BOWLER_COLOR,
  BATSMAN_COLOR,
  NATURAL_COLOR,
  NEUTRAL_COLOR,
  GAME_BOARD_BG_COLOR,
  GAME_BOARD_BG_COLOR_WITH_OPACITY,
  PLAYER_BOARD_TEXT_COLOR,
  BANKER_BOARD_TEXT_COLOR,
  TIE_BOARD_TEXT_COLOR,
  PLAYER_BOARD_DARK_TEXT_COLOR,
  BANKER_BOARD_DARK_TEXT_COLOR,
  TIE_BOARD_DARK_TEXT_COLOR,
  BOARD_COLORS,
  PANDA_EIGHT_COLOR,
  DRAGON_SEVEN_COLOR,
};
